$(document).ready(function () {
  let $outbox = $(".blogs-contentwrapper")

  const itemsPerPage = 9; // 每页显示的项目数
  const maxPageButtons = 5; // 最大页码按钮显示数量 
  const secidlast = 'blogsid'; // 
  let currentSearchResults = $outbox.find(".blogsbt-articleitem"); // 直接存储为jQuery对象

  // 显示当前页面的项目
  function showPage(page, faqItems) {
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    faqItems.hide(); // 隐藏所有项目
    faqItems.slice(start, end).show(); // 只显示当前页的项目
  }

  // 更新分页按钮
  function updatePagination(currentPage, faqItems) {
    const totalItems = faqItems.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const paginationSelector = `#pagination-${secidlast}`; // 动态选择分页ID

    // 如果只有一页，隐藏分页和前后按钮
    if (totalPages <= 1) {
      $(paginationSelector).hide(); // 隐藏分页
      return;
    }else{
        $(paginationSelector).show();
    } 

    // 清除旧的页码按钮（保留前后按钮）
    $(`${paginationSelector} .page-btn:not(.prev-btn-${secidlast}):not(.next-btn-${secidlast})`).remove();
    $(`${paginationSelector} .ellipsis`).remove();
    // 如果总页数大于5页，使用 "..." 展示部分页码
    if (totalPages > maxPageButtons) {
      if (currentPage <= 3) {
        // 如果当前页在前3页，显示前3页和 "..."
        for (let i = 1; i <= 3; i++) {
          $(paginationSelector)
            .find(`.next-btn-${secidlast}`)
            .before(`<button class="page-btn" data-page="${i}">${i}</button>`);
        }
        $(paginationSelector).find(`.next-btn-${secidlast}`).before('<span class="ellipsis">...</span>');
        $(paginationSelector)
          .find(`.next-btn-${secidlast}`)
          .before(`<button class="page-btn" data-page="${totalPages}">${totalPages}</button>`);
      } else if (currentPage >= totalPages - 2) {
        // 如果当前页在后3页，显示最后3页和 "..."
        $(paginationSelector)
          .find(`.next-btn-${secidlast}`)
          .before(`<button class="page-btn" data-page="1">1</button>`);
        $(paginationSelector).find(`.next-btn-${secidlast}`).before('<span class="ellipsis">...</span>');
        for (let i = totalPages - 2; i <= totalPages; i++) {
          $(paginationSelector)
            .find(`.next-btn-${secidlast}`)
            .before(`<button class="page-btn" data-page="${i}">${i}</button>`);
        }
      } else {
        // 否则，显示当前页附近的3页，左右各显示一页
        $(paginationSelector)
          .find(`.next-btn-${secidlast}`)
          .before(`<button class="page-btn" data-page="1">1</button>`);
        $(paginationSelector).find(`.next-btn-${secidlast}`).before('<span class="ellipsis">...</span>');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          $(paginationSelector)
            .find(`.next-btn-${secidlast}`)
            .before(`<button class="page-btn" data-page="${i}">${i}</button>`);
        }
        $(paginationSelector).find(`.next-btn-${secidlast}`).before('<span class="ellipsis">...</span>');
        $(paginationSelector)
          .find(`.next-btn-${secidlast}`)
          .before(`<button class="page-btn" data-page="${totalPages}">${totalPages}</button>`);
      }
    } else {
      // 如果总页数小于等于5，直接显示所有页码
      for (let i = 1; i <= totalPages; i++) {
        $(paginationSelector)
          .find(`.next-btn-${secidlast}`)
          .before(`<button class="page-btn" data-page="${i}">${i}</button>`);
      }
    }

    // 启用/禁用 "上一页" 和 "下一页" 按钮
    $(`.prev-btn-${secidlast}`).prop('disabled', currentPage === 1);
    $(`.next-btn-${secidlast}`).prop('disabled', currentPage === totalPages);

    // 移除之前高亮的按钮，给当前页加高亮
    $(`${paginationSelector} .page-btn`).removeClass('active');
    $(`${paginationSelector} .page-btn[data-page='${currentPage}']`).addClass('active');

    // 显示当前页的项目
    showPage(currentPage, faqItems);
  }

  // 初始化分页
  function initPagination(faqItems) {
    const currentPage = 1;
    updatePagination(currentPage, faqItems); 
  }

  // 分页按钮的点击事件
  $(`#pagination-${secidlast}`).on('click', '.page-btn', function () {
    const currentPage = parseInt($(this).data('page')); // 获取当前页码
    updatePagination(currentPage, currentSearchResults); 
  });

  // "上一页" 和 "下一页" 按钮点击事件
  $(`#pagination-${secidlast}`).on('click', `.prev-btn-${secidlast}, .next-btn-${secidlast}`, function () {
    const paginationSelector = `#pagination-${secidlast}`;
    let currentPage = parseInt($(`${paginationSelector} .page-btn.active`).data('page'));

    // 点击上一页或下一页按钮
    if ($(this).hasClass(`prev-btn-${secidlast}`)) {
      currentPage = Math.max(1, currentPage - 1);
    } else if ($(this).hasClass(`next-btn-${secidlast}`)) {
      const totalPages = Math.ceil(currentSearchResults.length / itemsPerPage);
      currentPage = Math.min(currentPage + 1, totalPages);
    }

    updatePagination(currentPage, currentSearchResults); 
  });


  initPagination(currentSearchResults); // 初始化所有项




  function showSearchFaqsItems(faqtext) {
      if(faqtext == 'All'){
        $outbox.find(".blogsbt-articleitem").show();
        currentSearchResults = $outbox.find(".blogsbt-articleitem");
      }else{
        const searchText = String(faqtext).trim().toLowerCase();
  
        const newResults = $(); 
    
        $outbox.find(".blogsbt-articleitem").show();
        $outbox.find(".blogsbt-articleitem").each(function () {
            const faqTitle = $(this).attr('data-tags').toLowerCase();
            let isMatch = true;
                if (!faqTitle.includes(searchText)) {
                    isMatch = false;
                }
  
    
            if (isMatch) {
                $(this).show();
                newResults.push(this); 
            } else {
                $(this).hide();
            }
        });
  
        currentSearchResults = newResults; 
      }
      
      initPagination(currentSearchResults); 
  }
  

  $(".blogs-allnavsitem").click(function(){
    $(this).addClass("active").siblings().removeClass("active");
     let tagname = $(this).data("tag");
     showSearchFaqsItems(tagname);
  })
  
  


})